export default [
  {
    path: 'create/',
    name: 'InvoiceAdd',
    meta: {
      title: 'Add Invoice',
      masterModal: 'create'
    },
    children: [
      {
        path: ':customerId',
        name: 'InvoiceAddCustomer',
        meta: {
          title: 'Add Invoice',
          masterModal: 'create',
        }
      },
      {
        path: ':customerId/:projectId',
        name: 'InvoiceAddProject',
        meta: {
          title: 'Add Invoice',
          masterModal: 'create',
        }
      }
    ]
  },
  {
    path: 'edit/:invoiceId',
    name: 'InvoiceEdit',
    meta: {
      title: 'Edit Invoice',
      masterModal: 'edit'
    }
  },
  {
    path: 'view/:invoiceId',
    name: 'InvoiceView',
    meta: {
      title: 'View Invoice',
      masterModal: 'view'
    }
  },
  {
    path: 'view/:invoiceId/recurrent',
    name: 'InvoiceViewRecurrent',
    meta: {
      title: 'View Invoice',
      masterModal: 'view',
      recurrent: true
    }
  },
  {
    path: 'send/:invoiceId/recurrent',
    name: 'InvoiceSendRecurrent',
    meta: {
      title: 'Send Invoice',
      masterModal: 'send',
      recurrent: true
    }
  },
  {
    path: 'payment/:invoiceId',
    name: 'InvoicePayments',
    meta: {
      title: 'Invoice payments',
      masterModal: 'payments'
    }
  },
  {
    path: 'send/',
    name: 'InvoiceSendHome',
    meta: {
      title: 'Send Invoices',
      masterModal: 'send'
    },
    children: [
      {
        path: ':invoiceId',
        name: 'InvoiceSend',
        meta: {
          title: 'Send Invoices',
          masterModal: 'send'
        }
      },
      {
        path: ':invoiceId/:emailMessageId',
        name: 'InvoiceSend',
        meta: {
          title: 'Send Invoices',
          masterModal: 'send'
        }
      },
    ]
  },
  {
    path: 'upload/',
    name: 'InvoiceUpload',
    meta: { title: 'Upload to Invoices', showUploadModal: true, modalType: 'upload' },
    children: [
      {
        path: 'invoice/add', name: 'InvoiceUploadInvoice',
        meta: {
          title: 'Upload Invoice',
          showUploadModal: true,
          modalType: 'upload',
          uploadType: 'invoice'
        }
      },
      {
        path: 'correction/add', name: 'InvoiceUploadCorrection',
        meta: {
          title: 'Upload Correction',
          showUploadModal: true,
          modalType: 'upload',
          uploadType: 'correction'
        }
      },
    ]
  },
]
